import {
    ConsentLevel,
    ScriptLoadResult,
    useScriptWithConsent,
} from '@news-mono/web-common'
import React, { useEffect } from 'react'
import { ConsentFallback } from '../../../tracking/ConsentFallback/ConsentFallback'
import { generateFrameSrc } from '../helpers/whistleout'

export interface WhistleOutProps {
    link: string
}

interface WhistleOutMessage {
    data: { sentinel?: string; url: string; height: number }
}

export const WhistleOut: React.FC<WhistleOutProps> = ({ link }) => {
    const [height, setHeight] = React.useState('264px') // initial height thats overridden by messaging
    const [result, error] = useScriptWithConsent({
        consentRequiredLevel: ConsentLevel.Advertising | ConsentLevel.Analytics,
        consentMet: {
            src: 'https://www.whistleout.com.au/js/responsive/es5.min.js',
        },
    })

    const sizeHandler = (event: WhistleOutMessage) => {
        const { data } = event
        if (
            data &&
            data.hasOwnProperty('sentinel') &&
            data.sentinel === 'whistleout-widget' &&
            data.url === generateFrameSrc(link)
        ) {
            setHeight(data.height + 'px')
        }
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('message', sizeHandler, false)
        }

        // Returned function called on unmount
        return () => {
            window.removeEventListener('message', sizeHandler, false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // only want it to run once

    const src = generateFrameSrc(link)

    if (result === ScriptLoadResult.NotConsented) {
        return <ConsentFallback />
    }

    if (!src || result !== ScriptLoadResult.Success || error) {
        return null
    }

    return (
        <iframe
            src={src}
            scrolling={'no'}
            frameBorder={0}
            height={height}
            width={'100%'}
        />
    )
}
